import { SITE } from "@/config/site";

// ============================================================
// FAQs — generic, editable answers. Update as needed.
// ============================================================

export const FAQS = [
  {
    question: "How can I book an appointment?",
    answer:
      "You can request an appointment through the Appointments page on this website, or message us directly on WhatsApp. Your request is sent to the hospital team, who will confirm your appointment.",
  },
  {
    question: "How do I contact the hospital?",
    answer: `You can call or WhatsApp us on ${SITE.phoneDisplay}. You will find Call and WhatsApp buttons on every page of this website.`,
  },
  {
    question: "Where is the hospital located?",
    answer: `${SITE.name} is located in ${SITE.location}. The exact street address will be updated here soon — please call us for directions in the meantime.`,
  },
  {
    question: "Can I request a specific doctor?",
    answer:
      "Yes. While requesting an appointment you can choose your preferred doctor, or mention the doctor's name in your WhatsApp message. The hospital will confirm availability.",
  },
  {
    question: "What are the doctor's consultation timings?",
    answer:
      "Consultation days and timings are listed on each doctor's profile page. Timings shown are demo values until the hospital confirms its actual schedule — please call to verify before visiting.",
  },
  {
    question: "How can I reach the hospital in an urgent situation?",
    answer: `For urgent medical assistance, please call ${SITE.phoneDisplay} directly so the hospital can guide you. Please confirm availability before visiting.`,
  },
  {
    question: "Is my information stored when I request an appointment?",
    answer:
      "No. This website does not store patient information. Appointment requests open WhatsApp on your own device, and the message is sent by you directly to the hospital.",
  },
  {
    question: "Do I need to confirm my appointment?",
    answer:
      "Yes. Appointment requests are subject to confirmation by the hospital. The team will reply to your WhatsApp message or call to confirm your slot.",
  },
];
